import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loadTrivia } from "../../actions";
import { QuizForm, QuizCard, Button } from "../../components";
import socket from "../../socket";
import "./styles.css";

const RoomPage = () => {
	const [users, setUsers] = useState([]);
	const [quizConfig, setQuizConfig] = useState({
		numberOfQuestions: "",
		category: "",
		difficulty: "",
		type: "",
		timer: 10
	});
	const [isStarted, setIsStarted] = useState(false);
	const { id } = useParams();
	const dispatch = useDispatch();
	const navigator = useNavigate();

	const handleLeave = () => {
		socket.emit("leave room", id);
		navigator("../lobby");
	};

	useEffect(() => {
		console.log(id);
		socket.emit("join room", id);
	}, [id]);

	useEffect(() => {
		socket.on("users", (data) => {
			setUsers(data);
		});
		return () => socket.off("users");
	}, []);

	useEffect(() => {
		socket.on("quiz configuration", (data) => {
			setQuizConfig(data);
		});
		return () => socket.off("quiz configuration");
	}, []);

	useEffect(() => {
		socket.on("trivia", (data) => {
			dispatch(loadTrivia(data));
			setIsStarted(true);
		});
		return () => socket.off("trivia");
	}, [dispatch]);

	useEffect(() => {
		socket.on("end trivia", () => {
			setIsStarted(false);
		});
		return () => socket.off("end trivia");
	});

	const renderQuestions = () => {
		return (
			<>
				<div className="gameContainer">
					<div className="gameWrapper">
						<QuizCard room={id} timer={quizConfig.timer} />
					</div>
				</div>
			</>
		);
	};

	if (isStarted) {
		return <>{renderQuestions()}</>;
	} else {
		return (
			<>
				<div className="gameContainer">
					<div className="gameWrapper">
						<Button
							onClick={() => {
								handleLeave();
							}}
							text={
								<>
									Leave<span></span>
									<span class="cybrBtnGlitch">Leave</span>
								</>
							}
						/>
						<div>
							{users.map((user) => {
								if (user === users[0]) {
									return <p>Leader: {user}</p>;
								} else {
									return <p>{user}</p>;
								}
							})}
							<h1>Room {id}</h1>
							{JSON.parse(localStorage.getItem("user")).username ===
							users[0] ? (
								<QuizForm room={id} />
							) : (
								<>
									<h1>Quiz configuration:</h1>
									<p>Questions: {quizConfig.numberOfQuestions}</p>
									<p>Timer: {quizConfig.timer}s</p>
									<p>Category: {quizConfig.category}</p>
									<p>Difficulty: {quizConfig.difficulty}</p>
									<p>Type: {quizConfig.type}</p>
								</>
							)}
						</div>
					</div>
				</div>
			</>
		);
	}
};

export default RoomPage;
